import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PROJECT_SELECTION_CHANGED_EVENT } from "./ProjectSwitcher";

/**
 * Component that provides application-wide refresh when projects are switched
 * This should be placed near the root of your component tree
 */
const AppRefreshProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [lastRefresh, setLastRefresh] = useState(Date.now());

  useEffect(() => {
    // Project-sensitive routes that should be refreshed when project selection changes
    const projectSensitiveRoutes = [
      "/collections",
      "/documents",
      "/playground",
      "/queries",
      "/dashboard",
    ];

    const handleProjectChange = (event) => {
      const currentPath = location.pathname;

      // Check if current route should be refreshed
      const shouldRefresh = projectSensitiveRoutes.some(
        (route) => currentPath.startsWith(route) || currentPath === route
      );

      if (shouldRefresh) {
        // Instead of a hard navigation, which would lose state and scroll position,
        // we'll set a state that can be used as a key or trigger for components to refresh
        setLastRefresh(Date.now());

        // Another option is to do a soft navigation:
        // navigate(currentPath, { replace: true, state: { refreshedAt: Date.now() } });

        // For specific detail pages we might want to force a refresh:
        // if (currentPath.match(/\/collections\/[a-zA-Z0-9-]+/)) {
        //   navigate(0); // Force full page refresh
        // }
      }
    };

    // Listen for project selection changes
    window.addEventListener(
      PROJECT_SELECTION_CHANGED_EVENT,
      handleProjectChange
    );

    return () => {
      window.removeEventListener(
        PROJECT_SELECTION_CHANGED_EVENT,
        handleProjectChange
      );
    };
  }, [location.pathname, navigate]);

  // Add the lastRefresh as a key to trigger re-rendering when projects change
  return (
    <React.Fragment key={`refresh-${lastRefresh}`}>{children}</React.Fragment>
  );
};

export default AppRefreshProvider;
